<ng-container *ngIf="currentStep$ | async as currentStep">
  <ibk-step-wizard *ngIf="currentStep > 1" [attr.current-step]="currentStep" class="step-wizard" [steps]="maxSteps">
  </ibk-step-wizard>
</ng-container>

<ng-template #content let-isClient="isClient" let-company="company">
  <ng-container [ngSwitch]="viewRouter.route$ | async">
    <ng-container *ngIf="dataCollectionForm as form" [formGroup]="form">
      <ba-data-collection 
      *ngSwitchCase="baRoutes.DATA_COLLECTION"
      ></ba-data-collection>
    </ng-container>

    <ba-legal-person-startup-step
      *ngSwitchCase="baRoutes.STARTUP"
      [ruc]="documentNumber"
      [name]="company?.businessName"
      (stepDone)="onStartupStepDone()"
    ></ba-legal-person-startup-step>

    <ba-equifax-authorization-step
      *ngSwitchCase="baRoutes.AUTHORIZE"
      [documentNumber]="legalRepresentantNumber"
      [documentType]="DocumentType.DNI"
      (stepDone)="onAuthorizationStepDone()"
    ></ba-equifax-authorization-step>

    <ba-legal-person-data-collection *ngSwitchCase="baRoutes.DATA_COLLECTION"
    ></ba-legal-person-data-collection>

    <ng-container *ngIf="dataForm as form" [formGroup]="form">
      <ba-legal-person-data-step
        [isClient]="isClient"
        [usePartnersForm]="shouldUsePartnersForm(company)"
        [useContributorForm]="!company || (company && !(company.consitutionDate || company.societyType))"
        [ruc]="documentNumber"
        *ngSwitchCase="baRoutes.BUSINESS_DATA"
        (stepDone)="onDataStepDone()"
      ></ba-legal-person-data-step>
    </ng-container>

    <ng-container *ngIf="otpForm as form" [formGroup]="form">
      <ba-otp-step
        [documentNumber]="documentNumber"
        [isClient]="isLegalRepresentativeClient"
        [firstWindow]="firstWindow"
        [ruc]="ruc"
        *ngSwitchCase="baRoutes.OTP"
        (stepDone)="onOtpStepDone()"
        (exitFlowCreateAccount)="exitFlowCreateAccount.emit()"
      ></ba-otp-step>
    </ng-container>

    <!-- TODO: Agregar ng container y el form representante -->
    <ng-container *ngIf="legalRepresentativeForm" [formGroup]="legalRepresentativeForm">
      <ba-legal-representative-step
        *ngSwitchCase="baRoutes.REP_DATA"
        [ruc]="ruc"
        [isClient]="isClient"
        [isLegalRepresentativeClient]="isLegalRepresentativeClient"
        [legalRepresentantNumber]="legalRepresentantNumber"
        (stepDone)="onLegalRepresentativeStepDone()"
      ></ba-legal-representative-step>
    </ng-container>

    <ng-container *ngIf="configForm as form" [formGroup]="form">
      <ba-legal-person-configuration-step
        *ngSwitchCase="baRoutes.CONFIGURATION"
        [accountsNumber]="accountsNumber"
        [isButtonDisabled]="isButtonDisabled"
        [showErrorDisclaimer]="showErrorDisclaimer"
        [showWarnDisclaimer]="showWarnDisclaimer"
        [isLoading]="isConfigutarionStepLoading"
        (stepDone)="onConfigurationStepDone()"
      ></ba-legal-person-configuration-step>
    </ng-container>

    <ba-legal-person-success-step
      *ngSwitchCase="baRoutes.SUCCESS"
      (stepDone)="onSuccessStepDone()"
    ></ba-legal-person-success-step>
  </ng-container>
</ng-template>

<ng-container *ngIf="(company$ | async)?.company as company; else notClientTmpl">
  <ng-container
    *ngTemplateOutlet="
      content;
      context: {
        isClient: true,
        company: company
      }
    "
  ></ng-container>
</ng-container>
<ng-template #notClientTmpl>
  <ng-container
    *ngTemplateOutlet="
      content;
      context: {
        isClient: false
      }
    "
  ></ng-container>
</ng-template>
